import { Trigger } from "./Trigger";

export class NewObject extends Trigger {
    public override async validate(): Promise<void> {
        // Prázdná metoda
    }
}
